export default "__VITE_ASSET__c65d947b__"